import Vue from 'vue';

// When the request succeeds
const success = (data, context) => {
  toastr.success(data.msg);
  context.smallLoading = false;
  context.closeModal ('#send-invoice-modal');
};

// When the request fails
const failed = (context, error) => {
  context.smallLoading = false;
  context.showToasterError(error);
};

export default (sendInvoice, context) => {
  return Vue.$http.post('/send-invoice', sendInvoice, {

  }).then((response) => {
      if (response.status === 200) {
        success(response.data, context);
      }
    })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/invoice/sendInvoice.js